var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { useDVSBoolean } from '@doordash/lib-dvs-client/lib/react';
import { Stack } from '@doordash/design-language';
import { FullScreenBlankContainer } from '../../core/AppLayoutV2/FullScreenLayout/FullScreenLayoutStyles';
import Header from '../../core/AppLayoutV2/FullScreenLayout/FullScreenLayoutHeader';
import { TitleContainer, PageTitleText, PageSubtitleText, FlexContainer, ContactSalesScreenContainer, RedBackgroundContainer, FormContainer, } from './ContactSalesStyles';
import ContactSalesStrings from './ContactSalesStrings';
import { LeadForm } from './components/LeadForm';
import { useCreateSelfServeLeadMutation } from './useCreateSelfServeLeadMutation';
import { TEAM_ACCOUNT_COUNTRY_CODE } from '../../types/portal_data';
import ThankYouDisplay from './components/ThankYouDisplay';
import track from '../../utils/track';
import { ContactSalesEvents } from '../../constants/events';
import { FREQUENCY_OF_USE_VALUES } from './constants';
import { DV2_NAMES, dv2Defaults } from '../../core/DV2';
var TitleContent = function () {
    return (React.createElement(TitleContainer, null,
        React.createElement(PageTitleText, null, ContactSalesStrings.pageTitle()),
        React.createElement(Stack, null),
        React.createElement(PageSubtitleText, null, ContactSalesStrings.pageSubtitle())));
};
export var ContactSales = function () {
    var history = useHistory();
    var _a = __read(React.useState(false), 2), isThankYouDisplayShow = _a[0], setIsThankYouDisplayShow = _a[1];
    var _b = __read(React.useState(''), 2), leadFormError = _b[0], setLeadFormError = _b[1];
    var _c = __read(React.useState(false), 2), showAdHocMessage = _c[0], setShowAdHocMessage = _c[1];
    var _d = useCreateSelfServeLeadMutation(), createLead = _d.createLead, isCreateLeadLoading = _d.loading;
    var useDdfbContactSalesNewFields = useDVSBoolean(DV2_NAMES.ddfbContactSalesNewFields, dv2Defaults[DV2_NAMES.ddfbContactSalesNewFields]);
    React.useEffect(function () {
        // fire event on page load
        track(ContactSalesEvents.PAGE_VIEW);
    }, []);
    var handleLeadFormSubmit = function (data) {
        // reset error
        setLeadFormError('');
        if (data.frequencyOfUse === FREQUENCY_OF_USE_VALUES.ADHOC) {
            setShowAdHocMessage(true);
        }
        var leadInfo = __assign(__assign({}, data), { companySize: useDdfbContactSalesNewFields ? data.companySize : undefined, frequencyOfMealDelivery: useDdfbContactSalesNewFields
                ? data.frequencyOfUse
                : undefined, countryCode: TEAM_ACCOUNT_COUNTRY_CODE.US });
        // PII info previously approved, used for cross-referencing in SFDC
        var leadFormTrackData = {
            first_name: data.firstName,
            last_name: data.lastName,
            email: data.email,
            phone: data.phoneNumber,
            company: data.companyName,
            companySize: data.companySize,
            frequencyOfMealDelivery: data.frequencyOfUse,
        };
        // call mutation
        createLead(leadInfo, {
            onCompleted: function (resp) {
                var _a;
                track(ContactSalesEvents.MARKETING_SUBMIT_LEAD_SUCESS, __assign(__assign({}, leadFormTrackData), { lead_id: (_a = resp === null || resp === void 0 ? void 0 : resp.createSelfServeLead) === null || _a === void 0 ? void 0 : _a.leadId }));
                setIsThankYouDisplayShow(true);
            },
            onError: function (error) {
                track(ContactSalesEvents.MARKETING_SUBMIT_LEAD_ERROR, __assign(__assign({}, leadFormTrackData), { error: JSON.stringify(error) }));
                setLeadFormError(ContactSalesStrings.leadFormErrorMessage());
            },
        });
    };
    var handleLeadFormBackClick = function () {
        track(ContactSalesEvents.MARKETING_LEAD_FORM_BACK_CLICK, {}, {}, function () {
            history.goBack();
        });
    };
    return (React.createElement(FullScreenBlankContainer, null,
        React.createElement(ContactSalesScreenContainer, null,
            React.createElement(Header, null),
            React.createElement(TitleContent, null),
            React.createElement(RedBackgroundContainer, null,
                React.createElement(FlexContainer, null,
                    React.createElement(FormContainer, null, isThankYouDisplayShow ? (React.createElement(ThankYouDisplay, { showAdHocMessage: showAdHocMessage })) : (React.createElement(LeadForm, { isLoading: isCreateLeadLoading, error: leadFormError, onSubmit: handleLeadFormSubmit, onBack: handleLeadFormBackClick }))))))));
};
export default ContactSales;
